<script setup lang="ts">
import Page from '@/shared/components/layouts/Page.vue';
import AssetTypeCriticalityWorkspace from '../../components/criticality/AssetTypeCriticalityWorkspace.vue';

definePage({ meta: { title: 'Asset Type Criticality' } });
</script>

<template>
  <Page>
    <AssetTypeCriticalityWorkspace />
  </Page>
</template>